export type CommonState = {
  readonly selectedSport: SportsResponse;
  readonly selectedSite: SitesResponse;
  readonly selectedSlate: SlateResponse;
  readonly authenticated: AuthResponse
  readonly displayedSlate: SlateResponse;
  readonly playerExposureDict: any;
  readonly stackExposureDict: any;
  readonly removedTeams: string[];
  readonly boostedTeams: {[key: string]: number}
}

export type SportsResponse = {
  readonly sport: string;
}

export type SitesResponse = {
  readonly site: string;
}

export enum App {
  SLATES = 'slates',
  DATA_HUB = 'projections',
  PROPS = 'props',
  SINGLE_LINEUP_SIMULATOR = 'singlelineupsim',
  CONTEST_GENERATOR = 'contest',
  PRE_CONTEST_SIMULATOR = 'pre',
  LATE_SWAP_SIMULATOR = 'late',
  POST_CONTEST_SIMULATOR = 'post',
  PICKEM = 'pickem',
  NBA_RATES = 'nbaRates',
  ROTATIONS = 'rotations',
  EXTERNAL = 'external',
}

export type MatchupInfo = {
 readonly awayTeamAbbrev : string;
 readonly awayTeamLogo : string;
 readonly awayTeamTitle : string;
 readonly gameTime : string;
 readonly homeTeamAbbrev : string;
 readonly homeTeamLogo : string;
 readonly homeTeamTitle : string;
 readonly homeTeamLineupConfirmed: boolean;
 readonly awayTeamLineupConfirmed: boolean;

}

export type SlateResponse = {
  readonly name: string;
  readonly startTime: string;
  readonly site: string;
  readonly sport: string;
  readonly type: string;
  readonly slateId: string;
  readonly matchupInfo: MatchupInfo;
  readonly allowedEntryCounts: number[];
  readonly lineupRules: { positions: string, teamSalary: number };
}

export type FullSlateResponse = {
  slates: SlateResponse[];
  sites: SitesResponse[];
  sports: SportsResponse[];
}

export type AuthResponse = {
  readonly authTier: string;
  readonly redirectUrl: string;
  readonly result: boolean;
  readonly userId: string;
}

